module.exports = __webpack_public_path__ + "static/media/check-mark-button.8c92249c.svg";